import React from 'react'
import { FiX } from 'react-icons/fi'
import { Icon } from '@chakra-ui/icons'
import { IconButton } from '@chakra-ui/react'

interface Props {
    onClick: () => void
}

export default function RemoveAttachmentButton({ onClick }: Props) {
    return (
        <IconButton
            icon={<Icon as={FiX} />}
            aria-label="Remove attachment"
            size="xs"
            position="absolute"
            top={2}
            right={2}
            color="white"
            borderWidth={1}
            bg="blackAlpha.500"
            _hover={{
                bg: 'blackAlpha.700',
            }}
            borderColor="white"
            rounded="full"
            onClick={onClick}
        />
    )
}
